import { SeatingPrefs } from '../../../constants/AppConstants';

export const radioGroups = [
    {
        name: 'direction',
        title: 'Direction',
        i18nPrefix: 'booking.seating',
        options: [
            { value: SeatingPrefs.NONE, key: 'noPreference' },
            { value: SeatingPrefs.FORWARDS, key: 'direction.forwards' },
            { value: SeatingPrefs.BACKWARDS, key: 'direction.backwards' },
        ],
    },
    {
        name: 'position',
        title: 'Position',
        i18nPrefix: 'booking.seating',
        options: [
            { value: SeatingPrefs.NONE, key: 'noPreference' },
            { value: SeatingPrefs.AISLE, key: 'position.aisle' },
            { value: SeatingPrefs.WINDOW, key: 'position.window' },
            { value: SeatingPrefs.INDIVIDUAL, key: 'position.individual' },
        ],
    },
    {
        name: 'seatType',
        title: 'Seat type',
        i18nPrefix: 'booking.seating',
        options: [
            { value: SeatingPrefs.NONE, key: 'noPreference' },
            { value: SeatingPrefs.AIRLINE, key: 'seatType.airline' },
            { value: SeatingPrefs.TABLE, key: 'seatType.table' },
        ],
    },
];
